import {
  Component,
  OnInit
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from '@angular/forms';
import {
  CotacaoService
} from '../../shared/Services/CotacaoService/cotacao-service.service';
import {
  Pasajero
} from '../../shared/Interfaces/Pasajero';
import {
  ObterMetodosPagamentoService
} from '../../shared/Services/ObterMetodosPagamento/obter-metodos-pagamento.service'
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from "@angular/common";
import { ModalMensajeComponent } from '../modal-mensaje/modal-mensaje.component';
import {debug} from 'util';

@Component({
  selector: 'app-pagamento',
  templateUrl: './pagamento.component.html',
  styleUrls: ['./pagamento.component.css']
})
export class PagamentoComponent implements OnInit {
  pagamentoForm = new FormGroup({

  })

  dadosCompradorForm = new FormGroup({
    //hidden: new FormControl('', Validators.required),
    nome: new FormControl('', Validators.required),
    sobreNome: new FormControl('', Validators.required),
    dataNascimento: new FormControl('', Validators.required),
    sexo: new FormControl('', Validators.required),
    cpf: new FormControl('', Validators.required),
    celular: new FormControl('', Validators.required),
    email: new FormControl('', Validators.required),
    cep: new FormControl('', Validators.required),
    rua: new FormControl(''),
    ruaNumber: new FormControl('', Validators.required),
    complemento: new FormControl(''),
    bairro: new FormControl(''),
    cidade: new FormControl(''),
    uf: new FormControl('')
  })

  dadosEmergenciaForm = new FormGroup({
    nomeE: new FormControl('', Validators.required),
    sobreNomeE: new FormControl('', Validators.required),
    celularE: new FormControl('', Validators.required),
    emailE: new FormControl('', Validators.required),
  })

  dadosPagamentoForm = new FormGroup({
    marcaTarjeta: new FormControl('', Validators.required),
    qParcelas: new FormControl('', Validators.required),
    nomeCartao: new FormControl('', Validators.required),
    numCartao: new FormControl('', Validators.required),
    validadeCartao: new FormControl('', Validators.required),
    cvv: new FormControl('', Validators.required)
  })

  PasajerosForm = new FormGroup({
    pasajero: this.fb.array([])
  })

  address: any = {};
  Dolar: any;
  DolarDate: any;
  ShowTelefono: boolean;
  telefono: string;
  cupom: string;
  ShowCupon: boolean;
  productoSeleccionado: any;
  MotivoViagem: any;
  datosStorage: any;
  AdicionalesSelected: any = [];
  CantCuotas: number = 0;
  valorTotal: any = 0;
  valorCuotas: number = 0;
  adicionales: Array<any> = [];
  PoliticamenteExpuesto: any = false;
  totalPasajeros: Array<Pasajero> = [];
  dadosCotisacion: any;
  motivoViagem: any;
  motivoViaje: any;
  cupomDescuento: any;
  suma: number;
  totalPeriodo: number;

  displayMonths = 2;
  navigation = 'select';
  showWeekNumbers = false;
  outsideDays = 'visible';
  public formasPagamento: any;
  quantidadeParcelas: any;
  submitted: boolean;
  showModalBox: boolean;
  cepinvalid: boolean;
  pasajeroComprador: boolean = false;
  destino: string = "";
  codigoTipoProducto: any;
  urlmostrarProductos: string;
  URLCotizacion: any;
  public customPatterns = { 'S': { pattern: new RegExp('\[a-zA-Z \]')} };

  constructor(private fb: FormBuilder,
              private cotacaoService: CotacaoService,
              private obterMetodoPagamento: ObterMetodosPagamentoService,
              private navigate: Router,
              private modalService: NgbModal,
              private location: Location

  ) { }

  ngOnInit() {
    this.URLCotizacion = JSON.parse(localStorage.URLParams);
    this.motivoViagem = localStorage.getItem('MotivoViagem');
    this.destino = localStorage.getItem('DescripcionDestino');

    this.codigoTipoProducto = localStorage.codigoTipoProducto;

    this.codigoTipoProducto = this.codigoTipoProducto.replace('"MV"', 'MV');

    this.suma = Number(JSON.parse(localStorage.dadosCotizacionL).quantPassageirosMenor) + Number(JSON.parse(localStorage.dadosCotizacionL).quantPassageirosMaior);

    this.address = {
      City: "",
      Neighborhood: "",
      StateCode: "",
      Street: "",
      CountryCode: "BRA",
      Floor: "",
      Number: "",
      OfficeOrAppartment: "",
      ZipCode: ""
    }

    for (let index = 0; index < this.suma; index++) {
      this.totalPasajeros.push({
        Nome: "",
        Sobrenombre: "",
        DataNacimiento: "",
        Sexo: "",
        CPF: "",
        Celular: "",
        Email: "",
        PoliticamenteExpuesto: false,
        ParentezcoPE: "",
        Menor: "",
        showRequired: "",
        showRequiredNome: "",
        showRequiredSobreNome: "",
        showRequiredDataNascimento: "",
        showRequiredSexo: "",
        showRequiredCPF: "",
        showRequiredCelular: "",
        showRequiredEmail: "",
        CEP: ""
      })
    }

    if (localStorage.AdicionalesSelected) {
      this.AdicionalesSelected = JSON.parse(localStorage.AdicionalesSelected);
    }
    //this.ConseguirCuotas();
    this.ConseguirCuotas();


    this.ConseguirCotizacionDolar();
    this.Dolar = sessionStorage.CotizacionDolar;
    this.DolarDate = sessionStorage.DateCotizacionDolar;

    if (sessionStorage.CotizacionDolar == '' || sessionStorage.CotizacionDolar == undefined) {
      this.Dolar = "0.00";
    }

    this.telefono = sessionStorage.getItem('Telefone');

    if (this.telefono == '' || this.telefono == undefined) {
      this.ShowTelefono = true;
    }

    this.cupom = sessionStorage.getItem('Cupom');

    if (this.cupom == '' || this.cupom == undefined) {
      this.ShowCupon = false;
    } {
      this.ShowCupon = true;
    }

    //this.productoSeleccionado = JSON.parse(localStorage.ProductoSeleccionado);
    this.productoSeleccionado = JSON.parse(localStorage.ProductoSeleccionado);

    this.valorTotal += this.productoSeleccionado.ValorProduto;

    // this.MotivoViagem = localStorage.motivoViagem;
    //this.MotivoViagem = localStorage.motivoViagem;

    this.datosStorage = JSON.parse(localStorage.getItem('dadosCotizacionL'));
    //let totalDias = volta.diff(ida, 'days');
    this.datosStorage.origem = localStorage.getItem('DescripcionOrigem');
    this.datosStorage.destino = localStorage.getItem('DescripcionDestino');

    if (this.motivoViagem === "M") {
      let dataVoltaMultiViagem = moment(this.datosStorage.dataIda).add(364, "days");
      this.datosStorage.dataVolta = {
        year: dataVoltaMultiViagem.year(),
        month: dataVoltaMultiViagem.month(),
        day: dataVoltaMultiViagem.date()
      }
      this.totalPeriodo = this.datosStorage.quantDias;
    } else {
      var volta =this.datosStorage.dataVolta.year + '-' + this.datosStorage.dataVolta.month + '-' + this.datosStorage.dataVolta.day;
      var ida = this.datosStorage.dataIda.year + '-' + this.datosStorage.dataIda.month + '-' + this.datosStorage.dataIda.day;
      this.totalPeriodo = moment(volta).diff(moment(ida), 'days') + 1;
    }

    this.datosStorage.dataIda.month = String(this.datosStorage.dataIda.month).padStart(2, '0');
    this.datosStorage.dataIda.day = String(this.datosStorage.dataIda.day).padStart(2, '0');
    this.datosStorage.dataVolta.month = String(this.datosStorage.dataVolta.month).padStart(2, '0');
    this.datosStorage.dataVolta.day = String(this.datosStorage.dataVolta.day).padStart(2, '0');


    let Adicionales = localStorage.AdicionalesSelected;
    if (Adicionales) {
      Adicionales = JSON.parse(Adicionales);

      Adicionales.forEach(adicional => {
        this.valorTotal += adicional.ValorCoberturaOpcional;
      });

    }

    this.valorCuotas = (this.valorTotal / this.CantCuotas);
  }

  get f() {
    return this.dadosPagamentoForm.controls;
  }

  get c() {
    return this.dadosCompradorForm.controls;
  }

  ConseguirCotizacionDolar() {
    this.cotacaoService.GetCotizacionDolar()
      .subscribe(
        data => {
          if (JSON.stringify(data.ResponseJSONData) !== '' || JSON.stringify(data.ResponseJSONData) !== undefined) {
            sessionStorage.setItem('CotizacionDolar', data.ResponseJSONData[0].ValorCotacao);
            sessionStorage.setItem('DateCotizacionDolar', data.ResponseJSONData[0].UltimoHorarioCotacao);
          }
        })
  }

  ConseguirCuotas() {

    this.motivoViaje = localStorage.MotivoViaje;

    const dadosCotacao = JSON.parse(localStorage.dadosCotizacionL);

    let Adicionales;

    if (localStorage.AdicionalesSelected) {
      Adicionales = JSON.parse(localStorage.AdicionalesSelected);

      Adicionales.forEach(adicional => {
        this.adicionales.push({
          parametername: "CoberturaAdicional",
          parameterlist: [{
            parametername: "CodigoCoberturaAdicional",
            parametervalue: adicional.CodigoCoberturaOpcional
          }]
        });
      });
    }

    this.cotacaoService.FormasPagamento(sessionStorage.SessionID,
      JSON.parse(localStorage.ProductoSeleccionado).CodigoProduto,
      JSON.parse(localStorage.codigoTipoProducto),
      localStorage.MotivoViagem,
      dadosCotacao.dataIda.year + '-' + String(dadosCotacao.dataIda.month).padStart(2, '0') + '-' + String(dadosCotacao.dataIda.day).padStart(2, '0'),
      dadosCotacao.dataVolta.year + '-' + String(dadosCotacao.dataVolta.month).padStart(2, '0') + '-' + String(dadosCotacao.dataVolta.day).padStart(2, '0'),
      JSON.parse(localStorage.dadosCotizacionL).quantDias,
      JSON.parse(localStorage.dadosCotizacionL).quantPassageirosMaior,
      JSON.parse(localStorage.dadosCotizacionL).quantPassageirosMenor,
      localStorage.CuponUsado,
      this.adicionales)
      .subscribe(
        data => {
          this.CantCuotas = data.ResponseJSONData.FormasPagamento.FormaPagamento[0].Parcela;
          let Cuotas = (Array.isArray(data.ResponseJSONData.FormasPagamento.FormaPagamento[0].Parcelas.Parcela)) ?
            data.ResponseJSONData.FormasPagamento.FormaPagamento[0].Parcelas.Parcela[data.ResponseJSONData.FormasPagamento.FormaPagamento[0].Parcelas.Parcela.length - 1]
            : data.ResponseJSONData.FormasPagamento.FormaPagamento[0].Parcelas.Parcela;
          this.CantCuotas = Cuotas.NumeroParcela;
          this.valorCuotas = Cuotas.ValorParcela;
          //this.valorTotal = Cuotas.NumeroParcela * Cuotas.ValorParcela;

          this.formasPagamento = data.ResponseJSONData.FormasPagamento.FormaPagamento;

          this.quantidadeParcelas = Array.isArray(this.formasPagamento[0].Parcelas.Parcela) ? this.formasPagamento[0].Parcelas.Parcela.map(val => val) : [this.formasPagamento[0].Parcelas.Parcela];
        });
  }

  // inicioVigencia() {
  //   let data = this.cotacaoForm.value.dataIda;
  //   let fechaNueva = moment(data.days).add(365, "days").format("DD/MM/YYYY");
  //   this.cotacaoForm.value.dataVolta = fechaNueva;
  // }


  onKey(event: any) { // without type info
    var date = event.target.value;
    if (date.match(/^\d{4}$/) !== null) {
      event.target.value = date + '-';
    } else if (date.match(/^\d{4}\-\d{2}$/) !== null) {
      event.target.value = date + '-';
    }
  }

  AplicarCupom() {

    this.dadosCotisacion = JSON.parse(localStorage.dadosCotizacionL);

    this.motivoViagem = localStorage.MotivoViagem;

    this.dadosCotisacion.cupom = this.cupom;

    this.cotacaoService.FazerCotacao(this.dadosCotisacion.origen, this.motivoViagem ? this.motivoViagem : "L", this.dadosCotisacion.incluiEuropa, this.dadosCotisacion.dataIda, this.dadosCotisacion.dataVolta, this.dadosCotisacion.quantPassageirosMaior, this.dadosCotisacion.quantPassageirosMenor, this.cupomDescuento,
      this.dadosCotisacion.quantDias, this.dadosCotisacion.quantDias, sessionStorage.SessionID)
      .subscribe(
        data => {
          if (JSON.stringify(data.ResponseJSONData) !== '' || JSON.stringify(data.ResponseJSONData) !== undefined) {
            localStorage.setItem('dadosCotizacionL', JSON.stringify(this.dadosCotisacion));
            sessionStorage.setItem('Cotizacion', JSON.stringify(data.ResponseJSONData));
            window.location.reload();
          }
        }
      )
  }

  validaCPF() {
    let dadosPagamento = this.pagamentoForm.value;
    let numeros, digitos, soma, i, resultado, digitos_iguais;
    digitos_iguais = 1;
    if (dadosPagamento.cpf.length < 11)
      return false;
    for (i = 0; i < dadosPagamento.cpf.length - 1; i++)
      if (dadosPagamento.cpf.charAt(i) != dadosPagamento.cpf.charAt(i + 1)) {
        digitos_iguais = 0;
        break;
      }
    if (!digitos_iguais) {
      numeros = dadosPagamento.cpf.substring(0, 9);
      digitos = dadosPagamento.cpf.substring(9);
      soma = 0;
      for (i = 10; i > 1; i--)
        soma += numeros.charAt(10 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0))
        return false;
      numeros = dadosPagamento.cpf.substring(0, 10);
      soma = 0;
      for (i = 11; i > 1; i--)
        soma += numeros.charAt(11 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1))
        return false;
      return true;
    } else
      return false;
  }

  validarDataNascimento() { //Colocar en onchange
    let dadosPagamento = this.pagamentoForm.value;
    let fechaNac = moment(dadosPagamento.dataNascimento); //ida
    let hoje = moment().format(); //volta
    let hoje2 = moment(hoje);
    let edade = hoje2.diff(fechaNac, 'years');
    if (edade < 18) {
      const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
      modalRef.componentInstance.Titulo = 'Error data';
      modalRef.componentInstance.Mensaje = 'O comprador deve ser maior de idade';
    }
  }

  //@ts-ignorets
  validarCEP() {
    let CEP = this.dadosCompradorForm.value.cep.replace('-', '');
    this.obterMetodoPagamento.consultaCEP(this.dadosCompradorForm.value.cep)
      .subscribe(
        data => {
          if (data.ResponseJSONData !== '' || data.ResponseJSONData !== undefined) {

            const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
            modalRef.componentInstance.Titulo = 'Error data';
            modalRef.componentInstance.Mensaje = 'O cep inserido nao é valido';
          }
        }
      )
  }

  VerifyNome(pasajero: Pasajero) {
    if (!pasajero.Nome || pasajero.Nome == "")
      pasajero.showRequiredNome = true;
    else
      pasajero.showRequiredNome = false;
  }


  VerifySobreNome(pasajero: Pasajero) {
    if (!pasajero.Sobrenombre || pasajero.Sobrenombre == "")
      pasajero.showRequiredSobreNome = true;
    else
      pasajero.showRequiredSobreNome = false;
  }


  VerifyDataNascimento(pasajero: Pasajero) {
    if (!pasajero.DataNacimiento || pasajero.DataNacimiento == "")
      pasajero.showRequiredDataNascimento = true;
    else
      pasajero.showRequiredDataNascimento = false;
  }

  VerifySexo(pasajero: Pasajero) {
    if (!pasajero.Sexo || pasajero.Sexo == "")
      pasajero.showRequiredSexo = true;
    else
      pasajero.showRequiredSexo = false;
  }


  VerifyCPF(pasajero: Pasajero) {
    let numeros, digitos, soma, i, resultado, digitos_iguais;
    digitos_iguais = 1;
    if (pasajero.CPF.length < 11)
      return false;
    for (i = 0; i < pasajero.CPF.length - 1; i++)
      if (pasajero.CPF.charAt(i) != pasajero.CPF.charAt(i + 1)) {
        digitos_iguais = 0;
        break;
      }
    if (!digitos_iguais) {
      numeros = pasajero.CPF.substring(0, 9);
      digitos = pasajero.CPF.substring(9);
      soma = 0;
      for (i = 10; i > 1; i--)
        soma += numeros.charAt(10 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0))
        pasajero.showRequiredCPF = true;
      numeros = pasajero.CPF.substring(0, 10);
      soma = 0;
      for (i = 11; i > 1; i--)
        soma += numeros.charAt(11 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1))
        pasajero.showRequiredCPF = true;

      pasajero.showRequiredCPF = false;
    } else
      pasajero.showRequiredCPF = true;
  }

  VerifyCelular(pasajero: Pasajero) {
    if (!pasajero.Celular || pasajero.Celular == "")
      pasajero.showRequiredCelular = true;
    else
      pasajero.showRequiredCelular = false;
  }

  VerifyEmail(pasajero: Pasajero) {
    if (!pasajero.Email || pasajero.Email == "")
      pasajero.showRequiredEmail = true;
    else
      pasajero.showRequiredEmail = false;
  }



  //

  VeriFyAllPasajeros(): boolean {
    let respuesta = true;

    this.totalPasajeros.forEach(pasajero => {
      pasajero.showRequiredNome = (!pasajero.Nome || pasajero.Nome == "");
      pasajero.showRequiredSobreNome = (!pasajero.Sobrenombre || pasajero.Sobrenombre == "");
      pasajero.showRequiredDataNascimento = (!pasajero.DataNacimiento || pasajero.DataNacimiento == "");
      pasajero.showRequiredSexo = (!pasajero.Sexo || pasajero.Sexo == "");
      pasajero.showRequiredCelular = (!pasajero.Celular || pasajero.Celular == "");
      pasajero.showRequiredEmail = (!pasajero.Email || pasajero.Email == "");
      //Validación CPF
      let numeros, digitos, soma, i, resultado, digitos_iguais;
      digitos_iguais = 1;
      if (pasajero.CPF.length < 11)
        pasajero.showRequiredCPF = true;

      for (i = 0; i < pasajero.CPF.length - 1; i++)
        if (pasajero.CPF.charAt(i) != pasajero.CPF.charAt(i + 1)) {
          digitos_iguais = 0;
          break;
        }
      if (!digitos_iguais) {
        pasajero.showRequiredCPF = false;
        numeros = pasajero.CPF.substring(0, 9);
        digitos = pasajero.CPF.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--)
          soma += numeros.charAt(10 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
          pasajero.showRequiredCPF = true;
        numeros = pasajero.CPF.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--)
          soma += numeros.charAt(11 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
          pasajero.showRequiredCPF = true;
      } else
        pasajero.showRequiredCPF = true;

      //Validación datos pasajero
      if (!respuesta)
        respuesta = !(pasajero.showRequiredNome || pasajero.showRequiredSobreNome || pasajero.showRequiredDataNascimento
          || pasajero.showRequiredSexo || pasajero.showRequiredCPF);
    });
    return respuesta;
  }

  //
  cargarPassageiroComprador() {

    this.pasajeroComprador = true;
    let dadosPagamento = this.dadosCompradorForm.value;

    this.totalPasajeros[0].Nome = dadosPagamento.nome;
    this.totalPasajeros[0].Sobrenombre = dadosPagamento.sobreNome;
    this.totalPasajeros[0].DataNacimiento = dadosPagamento.dataNascimento;
    this.totalPasajeros[0].Sexo = dadosPagamento.sexo;
    this.totalPasajeros[0].CPF = dadosPagamento.cpf;
    this.totalPasajeros[0].Celular = dadosPagamento.celular;
    this.totalPasajeros[0].Email = dadosPagamento.email;
    this.totalPasajeros[0].CEP = dadosPagamento.cep;

  }

  VaciarPassageiroComprador() {
    let dadosPagamento = this.pagamentoForm.value;
    this.pasajeroComprador = false;

    this.totalPasajeros[0].Nome = "";
    this.totalPasajeros[0].Sobrenombre = "";
    this.totalPasajeros[0].DataNacimiento = "";
    this.totalPasajeros[0].Sexo = "";
    this.totalPasajeros[0].CPF = "";
    this.totalPasajeros[0].Celular = "";
    this.totalPasajeros[0].Email = "";
    this.totalPasajeros[0].CEP = "";
  }

  validarFormasPagamento() {

  }

  isPasajerosValid(): boolean {
    let respuesta = true;
    this.totalPasajeros.forEach(pasajero => {
      if (pasajero.showRequiredCPF || pasajero.showRequiredCelular || pasajero.showRequiredDataNascimento || pasajero.showRequiredEmail || pasajero.showRequiredNome || pasajero.showRequiredSexo || pasajero.showRequiredSobreNome)
        respuesta = false;
    });
    return respuesta;
  }

  cep_change() {
    let CEP: any = this.dadosCompradorForm.value.cep;
    CEP = CEP.replace('.', '').replace('-', '');
    this.obterMetodoPagamento.consultaCEP(CEP)
      .subscribe(
        data => {
          if (!Array.isArray(data.ResponseJSONData)) {
            this.address.City = "";
            this.address.Neighborhood = "";
            this.address.StateCode = "";
            this.address.Street = "";
            //this.address.CountryCode="BRA";
            this.address.Floor = "";
            this.address.Number = "";
            this.address.OfficeOrAppartment = "";
            //this.address.ZipCode="";
            this.cepinvalid = true;
          }
          else {

            this.address.City = data.ResponseJSONData[0].ds_cidade;
            this.address.Neighborhood = data.ResponseJSONData[0].ds_bairro;
            this.address.StateCode = data.ResponseJSONData[0].cd_uf;
            this.address.Street = data.ResponseJSONData[0].ds_logradouro;
            //this.address.CountryCode="BRA";
            this.address.Floor = "";
            this.address.Number = "";
            this.address.OfficeOrAppartment = "";
            //this.address.ZipCode="";
            this.cepinvalid = true;
            this.cepinvalid = false;
          }

        }

      )


  }

  confirmar() {
    this.submitted = true;

    // if (this.dadosCompradorForm.invalid || this.dadosPagamentoForm.invalid) { return; }


    if (this.VeriFyAllPasajeros() && this.dadosPagamentoForm.valid && this.dadosCompradorForm.valid && !this.cepinvalid) {
      var Address = {
        City: this.dadosCompradorForm.value.cidade,
        Neighborhood: this.dadosCompradorForm.value.bairro,
        StateCode: this.dadosCompradorForm.value.uf,
        Street: this.dadosCompradorForm.value.rua,
        CountryCode: "BRA",
        Floor: this.dadosCompradorForm.value.complemento,
        Number: this.dadosCompradorForm.value.ruaNumber,
        OfficeOrAppartment: "",
        ZipCode: this.dadosCompradorForm.value.cep
      };
      var Buyer = {
        CPFNumber: this.dadosCompradorForm.value.cpf,
        DateOfBirth: this.dadosCompradorForm.value.dataNascimento,
        FirstName: this.dadosCompradorForm.value.nome,
        Gender: this.dadosCompradorForm.value.sexo,
        LastName: this.dadosCompradorForm.value.sobreNome,
        Address: Address,
        EmailAddress: this.dadosCompradorForm.value.email,
        IncludeInNewsLetters: "0",
        Celular: this.dadosCompradorForm.value.celular
      };
      var EmergencyContact = {
        FirstName: this.dadosEmergenciaForm.value.nomeE,
        LastName: this.dadosEmergenciaForm.value.sobreNomeE,
        Email: this.dadosEmergenciaForm.value.emailE,
        Celular: this.dadosEmergenciaForm.value.celularE
      };
      var oIda = JSON.parse(localStorage.dadosCotizacionL).dataIda;
      var dataIda = oIda.year + '-' + ((oIda.month < 10) ? ('0' + oIda.month) : oIda.month) + '-' + String(oIda.day).padStart(2, '0');
      var oVolta = JSON.parse(localStorage.dadosCotizacionL).dataVolta;
      var dataVolta = oVolta.year + '-' + ((oVolta.month < 10) ? ('0' + oVolta.month) : oVolta.month) + '-' + String(oVolta.day).padStart(2, '0');
      var validadeCartao = this.dadosPagamentoForm.value.validadeCartao.substring(0, 2) + '/' + this.dadosPagamentoForm.value.validadeCartao.substring(2)
      this.obterMetodoPagamento.emitir(
        sessionStorage.SessionID,
        JSON.parse(localStorage.AdicionalesSelected),
        Buyer,
        ((localStorage.MotivoViagem == 'M') ? JSON.parse(localStorage.dadosCotizacionL).quantDias : '0'), //Days
        JSON.parse(localStorage.dadosCotizacionL).origem, //DeparturePointCode
        JSON.parse(localStorage.dadosCotizacionL).destino, //DestinationCode
        localStorage.CuponUsado, //Cupom
        EmergencyContact, //EmergencyContact

        validadeCartao, //CCExpirationDate
        this.dadosPagamentoForm.value.nomeCartao, //CCHolder
        this.dadosPagamentoForm.value.numCartao, //CCNumber
        this.dadosPagamentoForm.value.cvv, //CCSecurityCode
        this.dadosPagamentoForm.value.marcaTarjeta, //FormOfPaymentCode
        this.dadosPagamentoForm.value.qParcelas, //NumberOfPayments

        JSON.parse(localStorage.ProductoSeleccionado).CodigoProduto, //ProductCode
        JSON.parse(localStorage.codigoTipoProducto), //ProductTypeCode
        localStorage.MotivoViagem, //PurposeOfTripCode
        dataIda, //ValidFrom
        dataVolta, //ValidTo
        this.totalPasajeros
      ).subscribe(data => {
        localStorage.setItem('emisionData', JSON.stringify(''));
        if (data.ResponseCode == 0) {
          if (data.ResponseJSONData["s:Envelope"]["s:Body"].CreateVoucherResponse.CreateVoucherResult.MessageCode["#text"] == "0") {
            localStorage.setItem('emisionData', JSON.stringify(data));
            //redireccionar
            localStorage.setItem('email', this.dadosCompradorForm.value.email);

            this.navigate.navigate(['/Confirmacao']);
          }
          else {

            const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });

            modalRef.componentInstance.Titulo = 'Erro';
            modalRef.componentInstance.Mensaje = data.ResponseJSONData["s:Envelope"]["s:Body"].CreateVoucherResponse.CreateVoucherResult.MessageDescription["#text"];
          }
        }
        else {
          const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });

          modalRef.componentInstance.Titulo = 'Error data';
          modalRef.componentInstance.Mensaje = data.ResponseDescription;
        }
      });
    }
    else {
      const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });

      modalRef.componentInstance.Titulo = 'Error data';
      modalRef.componentInstance.Mensaje = 'Error validaciones';

    }

  }

  GotoMostrarProductos() {
    this.navigate.navigate(['/MostrarProdutos']);
  }

  GotoFazerCotacao() {

    this.urlmostrarProductos = '/Cotacao?' + this.URLCotizacion;

    this.urlmostrarProductos.replace(' ', '');
    this.navigate.navigate(['/Cotacao'], { queryParams: this.URLCotizacion });

  }

}

